import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// The pdfs go in the public/docs folder

const documents = [
  {
      id: 1,
      title: "Project Summary",
      description: "",
      file: "/docs/Project Summary.pdf",
  },
    {
        id: 2,
        title: "Project Vision",
        description: "",
        file: "/docs/Project Vision.pdf",
    },
    {
        id: 3,
        title: "Business Requirements",
        description: "",
        file: "/docs/Business Requirements.pdf",
    }, {
        id: 4,
        title: "Project Plan",
        description: "",
        file: "/docs/Project Plan.pdf",
    }, {
        id: 5,
        title: "Requirements Analysis and Design",
        description: "",
        file: "/docs/Project Requirements Analysis and Design.pdf",
    }, {
        id: 6,
        title: "Wireframes (Deprecated)",
        description: "",
        file: "/docs/Wireframes.pdf",
    },
    {
        id: 7,
        title: "Status Report",
        description: "",
        file: "/docs/Status Report.pdf",
    },
];

function DocCard({ doc }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        padding: '1.75rem 2rem',
        border: '0.5px solid rgba(100,98,92,0.15)',
        background: hovered ? '#eeecea' : '#f4f3f0',
        transition: 'background 0.25s',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '2rem',
      }}
    >
      <div>
        <div style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '20px', fontWeight: 300,
          color: '#2e2d2a', marginBottom: '6px',
        }}>
          {doc.title}
        </div>
        <div style={{ fontSize: '12px', color: '#6b6963', lineHeight: 1.6 }}>
          {doc.description}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '12px', flexShrink: 0, paddingTop: '2px' }}>
        <a
          href={doc.file}
          target="_blank"
          rel="noreferrer"
          style={{
            fontSize: '11px', letterSpacing: '0.1em',
            textTransform: 'uppercase', color: '#3d6e78',
            textDecoration: 'none',
            borderBottom: '0.5px solid rgba(61,110,120,0.3)',
            paddingBottom: '1px',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => e.currentTarget.style.borderBottomColor = '#3d6e78'}
          onMouseLeave={e => e.currentTarget.style.borderBottomColor = 'rgba(61,110,120,0.3)'}
        >
          View &#x2197;
        </a>
        <a
          href={doc.file}
          download
          style={{
            fontSize: '11px', letterSpacing: '0.1em',
            textTransform: 'uppercase', color: '#9b9991',
            textDecoration: 'none',
            borderBottom: '0.5px solid rgba(155,153,145,0.3)',
            paddingBottom: '1px',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => e.currentTarget.style.borderBottomColor = '#9b9991'}
          onMouseLeave={e => e.currentTarget.style.borderBottomColor = 'rgba(155,153,145,0.3)'}
        >
          Download
        </a>
      </div>
    </div>
  );
}

export default function TidelineDocs() {
  const navigate = useNavigate();

  return (
    <div style={{
      background: '#f4f3f0',
      minHeight: '100vh',
      fontFamily: "'DM Mono', monospace",
    }}>
      {/* Nav bar */}
      <nav style={{
        height: '56px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 2.5rem',
        background: 'rgba(244,243,240,0.92)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '0.5px solid rgba(100,98,92,0.15)',
        position: 'sticky', top: 0, zIndex: 100,
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            fontSize: '11px', letterSpacing: '0.12em',
            textTransform: 'uppercase', color: '#6b6963',
            fontFamily: "'DM Mono', monospace",
            display: 'flex', alignItems: 'center', gap: '8px',
            padding: 0,
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#2e2d2a'}
          onMouseLeave={e => e.currentTarget.style.color = '#6b6963'}
        >
          &#x2190; Back
        </button>

        <span style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 300, fontSize: '16px',
          fontStyle: 'italic', color: '#2e2d2a',
          letterSpacing: '0.04em',
        }}>
          Documentation
        </span>
      </nav>

      {/* Content */}
      <main style={{ maxWidth: '760px', margin: '0 auto', padding: '5rem 2.5rem' }}>

        {/* Header */}
        <div style={{ marginBottom: '4rem' }}>
          <div style={{
            fontSize: '10px', letterSpacing: '0.22em',
            textTransform: 'uppercase', color: '#9b9991',
            marginBottom: '1.25rem',
            display: 'flex', alignItems: 'center', gap: '1rem',
          }}>
            Documentation
            <span style={{ flex: 1, height: '0.5px', background: 'rgba(100,98,92,0.15)', maxWidth: '60px' }} />
          </div>

          <h1 style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(36px, 5vw, 56px)',
            fontWeight: 300, lineHeight: 1.1,
            color: '#2e2d2a', marginBottom: '1.25rem',
          }}>
            CBC BSWA<br />
            <em style={{ fontStyle: 'italic', color: '#3d6e78' }}>Project Documentation</em>
          </h1>

          <p style={{
            fontSize: '13px', color: '#6b6963',
            lineHeight: 1.8, maxWidth: '480px',
          }}>
            The following documents outline the lifecycle of the CBC BSWA project.
          </p>
        </div>

        {/* Document list */}
        <div style={{
          border: '0.5px solid rgba(100,98,92,0.15)',
          borderRadius: '4px',
          overflow: 'hidden',
        }}>
          {documents.map((doc, i) => (
            <div key={doc.id} style={{
              borderTop: i === 0 ? 'none' : '0.5px solid rgba(100,98,92,0.15)',
            }}>
              <DocCard doc={doc} />
            </div>
          ))}
        </div>

        <p style={{
          marginTop: '2rem',
          fontSize: '11px', color: '#9b9991',
          lineHeight: 1.6,
        }}>
        </p>
      </main>
    </div>
  );
}
